<template>
  <div class="denta_promotion">
    <div>
      <div class="firstQuestion answer_shell center">
        <answer
          answer-title='Приветсвтие'

          v-bind:answer-audio.sync="scenario.parameters.mainQuestionAudio"
          v-bind:answer-text.sync="scenario.parameters.mainQuestionText"

          :is-saved=isSaved
          :client=scenario.client

          @generateAudioHandler="setMainQuestionAudio"
          @deleteAudioHandler="deleteMainQuestionAudio"
          @setAudioDuration="setMainQuestionAudioDuration"
        />
      </div>

      <div class="answers">

        <div class="afterYes answer_shell">
          <answer
            answer-title='Да'

            v-bind:answer-audio.sync="scenario.parameters.onYesAudio"
            v-bind:answer-text.sync="scenario.parameters.onYesText"

            :is-saved=isSaved
            :client=scenario.client

            @generateAudioHandler="setYesAudio"
            @deleteAudioHandler="deleteYesAudio"
          />
        </div>

        <div class="afterNo answer_shell">
          <answer
            answer-title='Нет'

            v-bind:answer-audio.sync="scenario.parameters.onNoAudio"
            v-bind:answer-text.sync="scenario.parameters.onNoText"

            :is-saved=isSaved
            :client=scenario.client

            @generateAudioHandler="setNoAudio"
            @deleteAudioHandler="deleteNoAudio"
          />
        </div>

        <div class="afterFail answer_shell">
          <answer
            answer-title='Молчание/неразборчиво'

            v-bind:answer-audio.sync="scenario.parameters.onFailAudio"
            v-bind:answer-text.sync="scenario.parameters.onFailText"

            :is-saved=isSaved
            :client=scenario.client

            @generateAudioHandler="setFailAudio"
            @deleteAudioHandler="deleteFailAudio"
            @setAudioDuration="setRepeatAudioDuration"
          />
<!--        </div>-->

<!--        <div class="afterSecondFail answer_shell">-->
          <answer
            answer-title='Второй раз молчание/неразборчиво'

            v-bind:answer-audio.sync="scenario.parameters.onSecondFailAudio"
            v-bind:answer-text.sync="scenario.parameters.onSecondFailText"

            :is-saved=isSaved
            :client=scenario.client

            @generateAudioHandler="setSecondFailAudio"
            @deleteAudioHandler="deleteSecondFailAudio"
          />
        </div>

      </div>
    </div>
    <div>
      <scenario-bar
        :name="name"
        v-bind:is-saved=isSaved
        :is-ready=scenario.isReady
        v-bind:scenario="scenario"
        @set="setScenario"
      />
    </div>
  </div>
</template>

<script>
  import Answer from '../Answer'
  import ScenarioBar from './ScenarioSaver'
  export default {
    props: ['name', 'campaignid'],
    components: {ScenarioBar, Answer},
    data() {
      return {
        scenario: {
          template: 'dentapromotion',
          client: '',
          parameters: {
            mainQuestionAudio: [],
            mainQuestionText: '',

            onYesAudio: [],
            onYesText: '',

            onNoAudio: [],
            onNoText: '',

            onFailAudio: [],
            onFailText: '',

            onSecondFailAudio: [],
            onSecondFailText: ''
          },
          checkDuration: true,
          isReady: false
        },

        isSaved: false
      }
    },
    methods: {
      setScenario(value) {
        this.scenario = value
        if (!this.isSaved) {
          this.isSaved = true
        }
      },
      setMainQuestionAudio(data) {
        this.scenario.parameters.mainQuestionAudio = this.generateAudio(data, {audio: this.scenario.parameters.mainQuestionAudio})
      },
      setYesAudio(data) {
        this.scenario.parameters.onYesAudio = this.generateAudio(data, {audio: this.scenario.parameters.onYesAudio})
      },
      setNoAudio(data) {
        this.scenario.parameters.onNoAudio = this.generateAudio(data, {audio: this.scenario.parameters.onNoAudio})
      },
      setFailAudio(data) {
        this.scenario.parameters.onFailAudio = this.generateAudio(data, {audio: this.scenario.parameters.onFailAudio})
      },
      setSecondFailAudio(data) {
        this.scenario.parameters.onSecondFailAudio = this.generateAudio(data, {audio: this.scenario.parameters.onSecondFailAudio})
      },
      generateAudio(data, answer) {
          if (data.type) {
            let audio = {
              type: data.type,
              url: data.url,
              param: data.paramName,
              number: data.number
            }
            let audioTmp = []
            audioTmp.push(audio)
            if (answer.audio) {
              for (let i = 0; i < answer.audio.length; i++) {
                audioTmp.push(answer.audio[i])
              }
            }
            audioTmp.sort((a, b) => (a.number > b.number) ? 1 : -1)
            return audioTmp
          } else {
            return []
          }
      },
      deleteMainQuestionAudio(data) {
        this.deleteAudio(this.scenario.parameters.mainQuestionAudio, data)
      },
      deleteYesAudio(data) {
        this.deleteAudio(this.scenario.parameters.onYesAudio, data)
      },
      deleteNoAudio(data) {
        this.deleteAudio(this.scenario.parameters.onNoAudio, data)
      },
      deleteFailAudio(data) {
        this.deleteAudio(this.scenario.parameters.onFailAudio, data)
      },
      deleteSecondFailAudio(data) {
        this.deleteAudio(this.scenario.parameters.onSecondFailAudio, data)
      },
      deleteAudio(audio, data) {
        if (audio) {
          for (var i = 0; i < audio.length; i++) {
            if (audio[i] === data) {
              audio.splice(i, 1)
            }
          }
        }
      },
      setMainQuestionAudioDuration(data) {
        this.setAudioDuration(this.scenario.parameters.mainQuestionAudio, data)
      },
      setRepeatAudioDuration(data) {
        this.setAudioDuration(this.scenario.parameters.onFailAudio, data)
      },
      setAudioDuration(audio, data) {
        if (audio && data && data.url && data.duration) {
          for (var i = 0; i < audio.length; i++) {
            if (audio[i].url === data.url) {
              audio[i].duration = data.duration
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
  .answer_shell {
    max-width: 512px;
    display: inline-block;
    /*margin-right: 32px;*/
    vertical-align: top;
    /*border: 1px double black; !* Параметры границы *!*/
    background-color: ghostwhite;
    padding: 10px;
    margin-top: 50px;
  }
  .answer_shell.firstQuestion {
    margin-top: 0;
    width: 45%;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .answers {
    text-align:center;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .answer_shell.afterYes {
    float: left;
  }
  .answer_shell.afterNo {

  }
  .answer_shell.afterFail {
    float:right;
  }

  .afterSecondFail.answer_shell {
    display: block;
  }

  .arrow {
    display: inline;
  }

  .arrows {
    width: 40%;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  /* 1812 */
  @media (max-width: 1814px) {
    .answer_shell {
      max-width: 384px;
    }
    .answer_shell.firstQuestion {
      max-width: unset;
    }
    .answer_shell .generate_audio_control .generate_button {
      margin-top: 40px;
    }
    .answer_shell .generate_audio_control .speaker {
      margin-left: -180px;
    }

    .answer textarea {
      min-height: 124px;
    }
  }
  @media (max-width: 1425px) {
    .answer_shell.afterFail {
      float:unset;
      display: block;
    }
  }
</style>

<style>
  .denta_promotion .answer .generation_radios {
    display: none;
  }
  .denta_promotion .generation_radios {
    display: none;
  }
  .denta_promotioninput[type=range].slider.is-small {
    width: 110px;
  }
  .denta_promotion .generate_audio_control {
    margin-top: 10px;
  }

  .denta_promotion .firstQuestion .player {
    width: 80%;
  }
  .denta_promotion .player .player-progress {
    width: 256px;
  }
  .denta_promotion .firstQuestion .player .player-progress {
    width: 400px;
  }
  .denta_promotion .answer .add_parameter {
    float: right;
    margin-top:-32px;
  }
  .denta_promotion .answer .label {
    text-align: left;
  }
  .denta_promotion .answer textarea {
    min-height: 73px;
  }
  .denta_promotion .firstQuestion .answer textarea {
    min-height: 124px;
  }

  .denta_promotion .afterFail.answer_shell .answer:last-child {
    margin-top:32px;
  }

  @media (max-width: 1814px) {
    .denta_promotion .answer_shell {
      max-width: 384px;
    }
    .denta_promotion .answer_shell.firstQuestion {
      max-width: unset;
    }
    .denta_promotion .answer_shell .generate_audio_control .generate_button {
      margin-top: 40px;
    }
    .denta_promotion .answer_shell .generate_audio_control .speaker {
      margin-left: -180px;
    }
    .denta_promotion .answer textarea {
      min-height: 124px;
    }
  }

  @media (max-width: 1425px) {
    .denta_promotion .answer_shell.afterFail {
      float:unset;
      display: block;
    }
  }

  .denta_promotion .player .volume input {
    width:53px;
  }
  .denta_promotion .firstQuestion .player .volume input {
    width:75px;
  }
</style>



// WEBPACK FOOTER //
// ScenarioDentaPromotion.vue?c487e634